/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Revoked_TitleInputs */

const en_agent_authorization_revoked_title = /** @type {(inputs: Agent_Authorization_Revoked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent access revoked`)
};

const zh_agent_authorization_revoked_title = /** @type {(inputs: Agent_Authorization_Revoked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 访问已撤销`)
};

/**
* | output |
* | --- |
* | "Agent access revoked" |
*
* @param {Agent_Authorization_Revoked_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_revoked_title = /** @type {((inputs?: Agent_Authorization_Revoked_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Revoked_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_revoked_title(inputs)
	return zh_agent_authorization_revoked_title(inputs)
});
export { agent_authorization_revoked_title as "agent.authorization.revoked_title" }